import { render, staticRenderFns } from "./KnowledgeFilter.vue?vue&type=template&id=bec32e9e&scoped=true&"
import script from "./KnowledgeFilter.vue?vue&type=script&lang=js&"
export * from "./KnowledgeFilter.vue?vue&type=script&lang=js&"
import style0 from "./KnowledgeFilter.vue?vue&type=style&index=0&id=bec32e9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bec32e9e",
  null
  
)

export default component.exports